import { Badge } from "@chakra-ui/react";

import { AdminLinearCleanupIssue } from "@reflag/shared/adminAPI";

const labels = {
  creating: { label: "Creating", color: "blue" },
  created: { label: "Created", color: "green" },
  failed: { label: "Failed", color: "red" },
  skipped: { label: "Skipped", color: "gray" },
};

export function LinearCleanupCreationStatusBadge({
  status,
}: {
  status: AdminLinearCleanupIssue["status"];
}) {
  const { label, color } = labels[status];
  return <Badge colorScheme={color}>{label}</Badge>;
}
